import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { setActivities } from 'bundles/apex/deals/show/store/activities/search/actions';

import Activities from 'bundles/apex/activities';
import Modal from './create/modal';

export function ActivityResults({
  activities,
  aiEnabled,
  deal,
  loading,
  setActivities,
  isBackofficeAdmin,
  forUserId,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className={classNames('deal-activity-results flex-1', { loading })}>
      <Activities
        activities={activities}
        aiEnabled={aiEnabled}
        forUserId={forUserId}
        isBackofficeAdmin={isBackofficeAdmin}
        parentId={deal?.id}
        parentType="Apex::Deal"
        onChange={setActivities}
        onEmptyStateClick={() => setShowModal(true)}
      />

      <Modal show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

ActivityResults.propTypes = {
  activities: PropTypes.array,
  aiEnabled: PropTypes.bool,
  deal: PropTypes.object,
  forUserId: PropTypes.number.isRequired,
  isBackofficeAdmin: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  setActivities: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  activities: state.activitiesSearch.activities,
  aiEnabled: state.features.aiTextGeneration,
  deal: state.deal,
  loading: state.activitiesSearch.loading,
  isBackofficeAdmin: state.forUser.apexAdmin,
  forUserId: state.forUser.id,
  forUser: state.forUser,
});



const mapDispatchToProps = {
  setActivities,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityResults);
